<small #tooltipText role="tooltip" [id]="id" *ngIf="text"
    class="pa-tooltip" [class.pa-tooltip-system]="!isAction" translate>{{ text }}</small>
